import { type AppState } from '../../common/types';

export const getCategoryMenuWidgetData = (state: AppState) => state.categoryMenuWidget;
